import { NavBar } from "../components/NavBar";
import { Footer } from "../components/Footer";

export function ContactoPage() {
  
  return (
    <div className="min-h-screen bg-[#f6f8fb] text-slate-800 flex flex-col">
      <NavBar isLogged={false} />

      <header className="bg-linear-to-r from-primary to-primary-hover text-white">
        <div className="mx-auto max-w-5xl px-6 py-10">
          <p className="text-xs uppercase tracking-[0.12em] text-white/80">Contacto</p>
          <h1 className="text-3xl font-bold">Hablemos</h1>
          <p className="mt-2 text-sm md:text-base text-white/90">
            ¿Tienes dudas sobre nuestros servicios o necesitas soporte técnico? Estamos aquí para ayudarte.
          </p>
        </div>
      </header>

      <main className="flex-1">
        <section className="mx-auto max-w-5xl px-6 py-12">
          <div className="gap-6 flex flex-col items-center justify-center">
            <div className="w-full max-w-md space-y-4 text-sm text-slate-700 rounded-2xl border border-slate-200 bg-white p-8 shadow-sm">
              <h2 className="text-lg font-bold text-slate-900 border-b pb-2">Información de contacto</h2>
              
              <div className="space-y-3 pt-2">
                <p className="flex items-center gap-2">
                  <span className="font-bold text-primary">Empresa:</span> 
                  NUOVOCELL
                </p>
                
                <p className="flex items-center gap-2">
                  <span className="font-bold text-primary">Correo electrónico:</span> 
                  admin@servix.com.ve
                </p>
                
                <p className="flex items-center gap-2">
                  <span className="font-bold text-primary">Sitio web:</span> 
                  https://servix.com.ve/
                </p>

                <p className="flex items-center gap-2">
                  <span className="font-bold text-primary">Atención legal:</span> 
                  Para gestión de datos o resolución de disputas.
                </p>
              </div>

              <div className="mt-6 p-4 bg-slate-50 rounded-lg border border-slate-100">
                <p className="text-xs text-slate-500 leading-relaxed italic">
                  * Todas las solicitudes de soporte y ejercicios de derechos de privacidad se gestionan exclusivamente vía correo electrónico.
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}